<template>
	<Autocomplete
		create
		display-name="Handwerkerauftrag Status"
		:icon="icon"
		:label="label"
		:name="name"
		item-title="name"
		endpoint="craftsman_task_statuses"
		data-test="craftsman_task_statuses-autocomplete"
		v-bind="$attrs"
		:params="{ of: 'name', od: 'ASC' }"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '../Validation/Autocomplete.vue'

defineProps({
	icon: {
		default: 'fa-regular fa-tasks-alt',
		type: String,
	},
	label: {
		default: 'Handwerkerauftrag Status',
		type: String,
	},
	name: {
		default: 'craftsmanTaskStatuses',
		type: String,
	},
})
</script>

<style scoped></style>
